module.exports = __webpack_public_path__ + "img/crowd.d18ae9cf.png";